import { useAuth } from "@/features/auth/hooks/useAuth"
import { Message } from "ably"
import { useChannel } from "ably/react"

export const useWebSocketCallback = (eventType: string, callback: (data: any) => void) => {
  const { user } = useAuth()

  return useChannel(`private-org-${user?.organization_id}-messages`, (message: Message) => {
    if (message.name === eventType) {
      callback(message.data)
    }
  })
}
